import * as React from 'react'

import {
  Box,
  type Colors,
  Icon,
  Text,
  Tooltip,
  useToggle,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import ValidateIban from 'modules/payroll_bundle/lib/ValidateIban'

interface Props {
  text: string
  iban?: boolean
  label?: string
  imported?: boolean
  color?: Colors
}

const ShowText = ({ text, label = '', color = 'grey600', iban }: Props) => {
  const [open, toggle] = useToggle(false)

  if (iban && !text) {
    return (
      <Text.Normal color="radicalRed1000">
        {i18n.t('payroll_bundle.results_payments.payments.table.not_informed')}
      </Text.Normal>
    )
  }

  if (iban && !ValidateIban(text)) {
    return (
      <Box flexDirection="row" alignItems="center">
        <Text.Normal color="radicalRed1000">{text}</Text.Normal>
        <Tooltip.Alt attachment="bottom center" open={open} toggle={toggle} label={label}>
          <Icon.Medium icon="alert-circle" color="grey800" />
        </Tooltip.Alt>
      </Box>
    )
  }

  if (text) return <Text.Normal>{text}</Text.Normal>

  return (
    <Tooltip.Alt attachment="top center" open={open} toggle={toggle} label={label}>
      <Text.Normal color={color}>--</Text.Normal>
    </Tooltip.Alt>
  )
}

export default ShowText
